'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _table = require('./table');

var _numberFormatting = require('../common/utils/number-formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var score = function score(irish, _score) {
  return irish ? _score.computedTotal.toFixed(1) + ' (' + _score.total.toFixed(1) + ')' : _score.total.toFixed(1);
};

var ScoresheetTable = function ScoresheetTable(_ref) {
  var _ref$persons = _ref.persons,
      persons = _ref$persons === undefined ? [] : _ref$persons,
      _ref$results = _ref.results,
      results = _ref$results === undefined ? [] : _ref$results,
      _ref$irishPoints = _ref.irishPoints,
      irishPoints = _ref$irishPoints === undefined ? false : _ref$irishPoints,
      _ref$rounds = _ref.rounds,
      rounds = _ref$rounds === undefined ? 1 : _ref$rounds,
      highlightPerson = _ref.highlightPerson;

  var roundNums = [].concat(_toConsumableArray(Array(rounds).keys())).map(function (i) {
    return i + 1;
  });

  var placeByRoundAndScore = roundNums.map(function (round) {
    var scores = results.map(function (result) {
      return result.scores[round - 1].value;
    }).sort(function (a, b) {
      return b - a;
    });

    return [null].concat(_toConsumableArray(scores));
  });

  var getPlace = function getPlace(result, i) {
    return (0, _numberFormatting.getOrdinal)(placeByRoundAndScore[i].indexOf(result.scores[i].value));
  };

  var roundHeaders = rounds > 1 ? roundNums.map(function (round) {
    return _react2.default.createElement(
      _table.Cell,
      { key: round, left: true, flex: 20 },
      'Round ',
      round
    );
  }) : null;

  var rows = results.map(function (result) {
    var person = persons.find(function (p) {
      return p.id === result.person;
    });
    var total = result.scores.reduce(function (total, _ref2) {
      var value = _ref2.value;
      return total + value;
    }, 0);

    return _react2.default.createElement(
      _table.Row,
      { style: { backgroundColor: highlightPerson === person.id ? '#FFFDE7' : '' } },
      _react2.default.createElement(
        _table.Cell,
        { center: true, flex: 5 },
        result.placement
      ),
      _react2.default.createElement(
        _table.Cell,
        { flex: 20 },
        person.competitor + ' - ' + person.fname + ' ' + person.lname
      ),
      rounds > 1 ? roundNums.map(function (i) {
        return _react2.default.createElement(
          _table.Cell,
          { left: true, flex: 20, key: i },
          getPlace(result, i - 1),
          ' - ',
          result.scores[i - 1].value
        );
      }) : null,
      _react2.default.createElement(
        _table.Cell,
        { right: true, flex: 15 },
        total.toFixed(1)
      ),
      irishPoints ? _react2.default.createElement(
        _table.Cell,
        { right: true, flex: 15 },
        result.computedTotal.toFixed(1)
      ) : null
    );
  });

  return _react2.default.createElement(
    _table.Table,
    null,
    _react2.default.createElement(
      _table.Header,
      null,
      _react2.default.createElement(
        _table.Cell,
        { center: true, flex: 5 },
        'Place'
      ),
      _react2.default.createElement(
        _table.Cell,
        { flex: 20 },
        'Competitor'
      ),
      roundHeaders,
      _react2.default.createElement(
        _table.Cell,
        { right: true, flex: 15 },
        'Total'
      ),
      irishPoints ? _react2.default.createElement(
        _table.Cell,
        { right: true, flex: 15 },
        'Irish Points'
      ) : null
    ),
    rows
  );
};

ScoresheetTable.propTypes = {
  persons: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object).isRequired,
  results: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object).isRequired,
  highlightPerson: _react2.default.PropTypes.string,
  irishPoints: _react2.default.PropTypes.bool,
  rounds: _react2.default.PropTypes.number
};

exports.default = ScoresheetTable;


//////////////////
// WEBPACK FOOTER
// ./result-list/scoresheet-table.js
// module id = 509
// module chunks = 0